import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => {
  return {
    root: {
      minWidth: theme.spacing(15),

      '& .react-select__menu': {
        zIndex: 10,
      },
    },
  };
});
